import { questionKey } from "@/utils/question";
import debounce from "lodash/debounce";

export const QuestionMixin = {
  props: {
    loading: {
      type: Boolean,
    },
    lang: {
      type: String,
    },
    question: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Number, Object, Date],
    },
    showQuestionCode: {
      type: [String, Number, Boolean],
      default: false,
    },
    shouldFocus:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isExclusive: false,
    };
  },
  computed: {
    qOpts() {
      return this.question?.options || {};
    },
    validationRules() {
      const rules = {};
      if (this.qOpts.mandatory) rules.mandatory = { type: this.question.type };

      if (this.question.type === "MI" && this.qOpts.type === "text") {
        if (this.qOpts.min)
          rules.min_length = { type: this.question.type, min: this.qOpts.min };
        if (this.qOpts.max)
          rules.max_length = { type: this.question.type, max: this.qOpts.max };
      } else if (this.qOpts.min && this.qOpts.max && !this.isExclusive)
        rules.between = {
          type: this.question.type,
          min: this.qOpts.min,
          max: this.qOpts.max,
        };
      else if (this.qOpts.min && !this.isExclusive)
        rules.min = {
          type: this.question.type,
          min: this.qOpts.min,
        };
      else if (this.qOpts.max)
        rules.max = {
          type: this.question.type,
          max: this.qOpts.max,
        };

      return rules;
    },

    questionHelp() {
      if (this.validationRules.between && this.question.type === "FU") {
        return this.$i18n.t("validations.messages.file_between", {
          min: this.validationRules.between.min,
          max: this.validationRules.between.max,
        });
      }

      if (this.qOpts.ext) {
        return this.$i18n.t("validations.messages.ext", {
          mimes: this.qOpts.ext,
        });
      }

      if (this.qOpts.size) {
        return this.$i18n.t("validations.messages.size", {
          size: this.qOpts.size,
        });
      }

      if (this.validationRules.between) {
        return this.$i18n.t("validations.messages.between", {
          min: this.validationRules.between.min,
          max: this.validationRules.between.max,
        });
      }

      if (this.validationRules.max) {
        return this.$i18n.t("validations.messages.max", {
          max: this.validationRules.max.max,
        });
      }

      if (this.validationRules.min) {
        return this.$i18n.t("validations.messages.min", {
          min: this.validationRules.min.min,
        });
      }

      if (this.validationRules.max_length) {
        return this.$i18n.t("validations.messages.max_length", {
          length: this.validationRules.max_length.max,
        });
      }

      if (this.validationRules.min_length) {
        return this.$i18n.t("validations.messages.min_length", {
          length: this.validationRules.min_length.min,
        });
      }

      if (this.validationRules.mandatory) {
        return this.$i18n.t("validations.messages.mandatory");
      }
    },
  },
  methods: {
    questionKey: questionKey,
    autoFocus: debounce(function() {
      if (this.isIos) return;
      const el = document.querySelectorAll(
        "INPUT[type=text],INPUT[type=number],TEXTAREA"
      )[0];
      if (el && this.shouldFocus) {
        el.focus();
        el.click();
        // el.scrollIntoView();
      }
    }, 250),
  },
  mounted() {
    this.$emit("mounted", "is-half");
    this.autoFocus();
  },
};
